/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  TestTablelandTablesNoConstructor,
  TestTablelandTablesNoConstructorInterface,
} from "../../../contracts/test/TestTablelandTablesNoConstructor";

const _abi = [
  {
    inputs: [],
    name: "ApprovalCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "BalanceQueryForZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidQueryRange",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "querySize",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxQuerySize",
        type: "uint256",
      },
    ],
    name: "MaxQuerySizeExceeded",
    type: "error",
  },
  {
    inputs: [],
    name: "MintERC2309QuantityExceedsLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "MintToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MintZeroQuantity",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnerQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnershipNotInitializedForExtraData",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferFromIncorrectOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToNonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "URIQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "Unauthorized",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toTokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "ConsecutiveTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "statement",
        type: "string",
      },
    ],
    name: "CreateTable",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isOwner",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "statement",
        type: "string",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "allowInsert",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "allowUpdate",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "allowDelete",
            type: "bool",
          },
          {
            internalType: "string",
            name: "whereClause",
            type: "string",
          },
          {
            internalType: "string",
            name: "withCheck",
            type: "string",
          },
          {
            internalType: "string[]",
            name: "updatableColumns",
            type: "string[]",
          },
        ],
        indexed: false,
        internalType: "struct TablelandPolicy",
        name: "policy",
        type: "tuple",
      },
    ],
    name: "RunSQL",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "controller",
        type: "address",
      },
    ],
    name: "SetController",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
    ],
    name: "TransferTable",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "string[]",
        name: "statements",
        type: "string[]",
      },
    ],
    name: "create",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "string",
        name: "statement",
        type: "string",
      },
    ],
    name: "create",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "string",
        name: "statement",
        type: "string",
      },
    ],
    name: "createTable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "explicitOwnershipOf",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "startTimestamp",
            type: "uint64",
          },
          {
            internalType: "bool",
            name: "burned",
            type: "bool",
          },
          {
            internalType: "uint24",
            name: "extraData",
            type: "uint24",
          },
        ],
        internalType: "struct IERC721AUpgradeable.TokenOwnership",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "explicitOwnershipsOf",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "startTimestamp",
            type: "uint64",
          },
          {
            internalType: "bool",
            name: "burned",
            type: "bool",
          },
          {
            internalType: "uint24",
            name: "extraData",
            type: "uint24",
          },
        ],
        internalType: "struct IERC721AUpgradeable.TokenOwnership[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
    ],
    name: "getController",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
    ],
    name: "lockController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "statement",
        type: "string",
      },
    ],
    name: "mutate",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tableId",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "statement",
            type: "string",
          },
        ],
        internalType: "struct ITablelandTables.Statement[]",
        name: "statements",
        type: "tuple[]",
      },
    ],
    name: "mutate",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "statement",
        type: "string",
      },
    ],
    name: "runSQL",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "controller",
        type: "address",
      },
    ],
    name: "setController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "tokensOfOwner",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stop",
        type: "uint256",
      },
    ],
    name: "tokensOfOwnerIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TestTablelandTablesNoConstructorConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestTablelandTablesNoConstructorConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestTablelandTablesNoConstructor__factory extends ContractFactory {
  constructor(...args: TestTablelandTablesNoConstructorConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<TestTablelandTablesNoConstructor> {
    return super.deploy(
      overrides || {}
    ) as Promise<TestTablelandTablesNoConstructor>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TestTablelandTablesNoConstructor {
    return super.attach(address) as TestTablelandTablesNoConstructor;
  }
  override connect(signer: Signer): TestTablelandTablesNoConstructor__factory {
    return super.connect(signer) as TestTablelandTablesNoConstructor__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestTablelandTablesNoConstructorInterface {
    return new utils.Interface(
      _abi
    ) as TestTablelandTablesNoConstructorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestTablelandTablesNoConstructor {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as TestTablelandTablesNoConstructor;
  }
}
